import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { Stack } from '@koob/margaret';
import { Container } from 'ui';
import {
  BookingRecap,
  SubHeader,
  RespondBooking,
} from 'components/HotelKeeper';
import HotelKeeperDocuments from './Partials/HotelKeeperDocuments';
import { getBookingBySecret, quickUpdateBooking } from 'api/node/hotelkeeper';
import { useError } from 'hooks';
import { useState } from 'react';
import { useAsync } from 'react-async';
import { AdminBookingStateEnum } from '@koob/enums';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.text};
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Logo = styled.img`
  margin: auto;
  width: 8.5rem;
  height: auto;
`;

const Header = styled(Stack).attrs({
  alignY: 'center',
})`
  padding: ${({ theme }) => theme.spacing(1.5)}
    ${({ theme }) => theme.spacing(2)};
  box-shadow: inset 0 -1px 0 0 rgba(0, 0, 0, 0.08);
  background-color: #fff;
`;

const Space = styled.div`
  flex: 1;
`;

const StickyBar = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 10;
`;

const HotelKeeper = () => {
  const { secret } = useParams();
  const { sendErrorSnack } = useError();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { data: bookingData, reload: refetch } = useAsync({
    promiseFn: getBookingBySecret,
    secret,
  });
  const booking = bookingData?.data;
  const organization = booking?.hotel?.organization;

  const handleSubmit = async (values) => {
    if (!secret) {
      return;
    }
    setIsSubmitting(true);
    try {
      await quickUpdateBooking({
        secret: secret,
        body: {
          hotelConfirmationNumber: values.hotelConfirmationNumber,
        },
      });
      refetch();
    } catch (error) {
      sendErrorSnack(error);
    }
    setIsSubmitting(false);
  };

  return (
    <Wrapper>
      {organization?.avatarUrl && organization.avatarUrl.trim() !== '' && (
        <Header>
          <Logo src={organization.avatarUrl} alt={organization.displayName} />
        </Header>
      )}

      <SubHeader booking={booking} kind="hotelKeeper" />

      <Container>
        <BookingRecap
          booking={booking}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          hotelKeeper
        />

        <HotelKeeperDocuments bookingId={booking?.id} secret={secret} />
      </Container>

      <Space />

      {booking?.state === AdminBookingStateEnum.SENT && (
        <StickyBar>
          <RespondBooking refetch={refetch} booking={booking} />
        </StickyBar>
      )}
    </Wrapper>
  );
};

export default HotelKeeper;
